import { renderTeammateFullName } from "@repo/app-types/entities/teammate";
import { isNotNullNotUndefined } from "@repo/app-types/helpers/utilities";
import type { FC } from "react";
import { signoutUser } from "../../api/supabaseService.js";
import { selectIsUsingSSO } from "../../features/company/companySlice.js";
import { selectTeammate } from "../../features/teammate/teammateSlice.js";
import { useAppSelector } from "../../hooks/hook.js";
import {
  UserProfileWidget,
  type UserProfileMenuItem,
} from "./userProfileWidget.js";

function buildUserProfileMenuItems(
  isUsingSSO: boolean,
): readonly UserProfileMenuItem[] {
  return [
    { key: "settings", label: "Settings", href: "/settings/profile" },
    isUsingSSO
      ? undefined
      : {
          key: "invite-teammates",
          label: "Invite teammates",
          href: "/settings/teammates",
        },
    {
      key: "knowledge-center",
      label: "Knowledge center",
      href: "https://help.alpharun.com/",
      opensInNewWindow: true,
    },
    {
      key: "contact-support",
      label: "Contact support",
      href: "mailto:support@alpharun.com",
      opensInNewWindow: true,
    },
    { key: "sign-out", label: "Sign out", onAction: () => void signoutUser() },
  ].filter(isNotNullNotUndefined);
}

export const UserProfileWidgetContainer: FC = () => {
  const teammate = useAppSelector(selectTeammate);
  const isUsingSSO = useAppSelector(selectIsUsingSSO);

  if (!teammate) {
    return null;
  }

  return (
    <UserProfileWidget
      name={renderTeammateFullName(teammate) ?? teammate.email}
      email={teammate.email}
      menuItems={buildUserProfileMenuItems(isUsingSSO)}
    />
  );
};
